<template>
    <div class="add-domain-container pb-3">
        <!-- Link to add a domain value -->
        <b-link
            v-if="!addDomainVisible"
            :class="addDomainVisible? null : 'collapsed'"
            :href="`#addDomainValue_${name}`"
            @click="$_showAddDomainValue()"
        >
            <em class="add-domain-closed fa fa-plus"></em>
            <em class="add-domain-open fa fa-minus"></em>&nbsp;{{
                $t('labelAddDomainValue')
            }}
        </b-link>
        <!-- Collapsed input field and add button -->
        <b-collapse
            :id="`addDomainValue_${name}`"
            accordion="add-domain-accordion"
            v-model="addDomainVisible"
            @shown="$_setFocus"
        >
            <div class="d-flex">
                <!-- Input field for the new domain -->
                <div class="add-input-container">
                    <x-input
                        :ref="`addDomainInput_${name}`"
                        :maxlength="domainValueMaxLength"
                        :state="newDomainState"
                        :invalidMessage="newDomainInvalidMessage"
                        @input="$_validateNewDomainValue()"
                        @blur="$_hideAddDomainValue()"
                        v-model="newDomainValue"
                        :justInvalidState="true"
                        autocomplete="off"
                    >
                    </x-input>
                </div>
                <!-- Button to add the new domain -->
                <div>
                    <b-button
                        @click="$_addDomainToList()"
                        variant="secondary"
                        :disabled="$_disableAddButton"
                    >
                        {{ $t('btnAddLabel') }}
                    </b-button>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        props: {
            name: { type: String, required: true },
            domainValues: { type: Array, required: true },
            domainValueMaxLength: { type: Number, required: true }
        },
        data() {
            return {
                newDomainValue: '',
                newDomainState: true,
                newDomainInvalidMessage: '',
                addDomainVisible: false,
                localDomainValues: null
            };
        },
        computed: {
            $_disableAddButton() {
                return (
                    this.newDomainValue.trim().length === 0 || !this.newDomainState
                );
            }
        },
        methods: {
            $_setFocus() {
                const inputField = this.$refs[`addDomainInput_${this.name}`];
                if (inputField) {
                    inputField.$refs.inputField.focus();
                }
            },
            $_showAddDomainValue() {
                this.addDomainVisible = true;
                this.newDomainValue = '';
                this.newDomainState = true;
                this.newDomainInvalidMessage = '';
            },
            $_validateNewDomainValue() {
                this.newDomainState = !this.localDomainValues.find((d) => {
                    return (
                        d.value.toLowerCase() ===
                        this.newDomainValue.trim().toLowerCase()
                    );
                });
                this.newDomainInvalidMessage = this.newDomainState
                    ? ''
                    : this.$t('labelDomainValueExists');
            },
            $_hideAddDomainValue() {
                setTimeout(() => {
                    this.addDomainVisible = false;
                }, 125);
            },
            $_addDomainToList() {
                const newDomainValue = this.newDomainValue.trim();
                if (newDomainValue.length > 0) {
                    const foundDomain = this.localDomainValues.find((d) => {
                        return (
                            d.value.toLowerCase() === newDomainValue.toLowerCase()
                        );
                    });
                    if (!foundDomain) {
                        this.localDomainValues.push({
                            key: newDomainValue,
                            value: newDomainValue
                        });
                    }
                    this.$emit('updateDomainValue', newDomainValue);
                    this.newDomainValue = '';
                    this.$_hideAddDomainValue();
                }
            }
        },
        watch: {
            domainValues: {
                handler: function (newVal) {
                    this.localDomainValues = JSON.parse(JSON.stringify(newVal));
                },
                deep: true,
                immediate: true
            },
            localDomainValues: function (newValue) {
                if (JSON.stringify(newValue) === JSON.stringify(this.domainValues)) {
                    return;
                }
                const locDomainValues = JSON.parse(JSON.stringify(newValue));
                this.$emit('updateKeyvalues', locDomainValues);
            }
        }
    };
</script>

<style lang="scss">
.add-input-container {
    & .form-group {
        margin-bottom: 0px;
    }
}
</style>

<style lang="scss" scoped>
.add-domain-container {
    margin-top: -15px;

    .add-input-container {
        width: 100%;
    }

    .collapsed > .add-domain-open,
    .not-collapsed > .add-domain-closed {
        display: none;
    }
}
</style>
